import { type UseControllerProps } from "react-hook-form";

import dayjs from "dayjs";
import { useFormContext, useWatch, useController } from "react-hook-form";
import { TextActionOptional } from "src/features/observations/components/TextActionOptional";

interface DateQuestionProps extends UseControllerProps<ObservationFormState> {
	questionNumber: number;

	staticInput?: boolean;

	selectFutureDates?: boolean;

	showAction?: boolean;
}

const DateQuestion = ({
	name,
	rules,
	questionNumber,
	staticInput,
	selectFutureDates,
	showAction
}: DateQuestionProps) => {
	const { control } = useFormContext<ObservationFormState>();

	const { field } = useController({
		control,
		name,
		rules
	});

	const { isDisabled } = useWatch({
		control
	});

	const value = field.value
		? dayjs(field.value as string | number | Date).format("YYYY-MM-DD")
		: "";

	return (
		<div>
			<div className="mt-4">
				<input
					id={`question-${questionNumber}`}
					type="date"
					name={name}
					value={value}
					max={selectFutureDates ? undefined : dayjs().format("YYYY-MM-DD")}
					disabled={isDisabled}
					onChange={(e) => {
						if (e.target.value) {
							field.onChange(`${e.target.value}T00:00:00.000Z`);
						} else {
							field.onChange(null);
						}
					}}
					className="w-full md:w-48 border border-border bg-white rounded-lg shadow-xs px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-ring"
				/>
			</div>

			{showAction && (
				<TextActionOptional
					name={`questions.${questionNumber - 1}.action`}
					questionNumber={questionNumber}
					staticInput={staticInput}
				/>
			)}
		</div>
	);
};

export { DateQuestion, type DateQuestionProps };
